import React, { useEffect } from 'react';
import { Mail, OctagonX, X } from 'lucide-react';
import { Button, Text, IconButton } from '../components/ui';
import { generateMailtoLink } from '../utils/emailTemplateHelper';
import useErrorModalStore from '../store/useErrorModalStore';
import useClickOutside from '../hooks/useClickOutside';

const ErrorModal = () => {
  const { isOpen, errorMessage, errorType, actionButton, closeErrorModal, params } =
    useErrorModalStore();
  const { postId, websiteUrl, userEmail } = params;
  // Use click outside hook to close modal
  const modalRef = useClickOutside(() => {
    closeErrorModal();
  });

  // Effect: manage body overflow on modal open/close
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleContactSupport = () => {
    const mailtoLink = generateMailtoLink(errorType, userEmail, {
      postId,
      websiteUrl,
      userEmail,
    });
    window.location.href = mailtoLink;
  };

  // Don't render if modal is not open
  if (!isOpen) {
    return null;
  }

  return (
    <div className='modal-overlay'>
      <div
        ref={modalRef}
        className='modal-content relative w-full max-w-2xl p-8 sm:p-12'
      >
        {/* Close Button */}
        <IconButton
          icon={X}
          onClick={closeErrorModal}
          variant='ghost'
          size='lg'
          tooltip='Close'
          tooltipPosition='bottom'
          className='absolute right-4 top-4 z-10'
        />

        {/* Content */}
        <div className='text-center'>
          <div className='mb-6'>
            <OctagonX className='mx-auto h-12 w-12 mb-2' style={{ color: 'var(--color-danger, #ef4444)' }} />
            <Text variant='heading' className='mb-4 text-[32px] md:text-inherit'>
              Something went wrong
            </Text>
            <Text variant='subtitle' className='mt-4'>
              {errorMessage}
            </Text>
          </div>

          {/* Action Buttons */}
          <div className='flex flex-col sm:flex-row justify-center gap-3 mt-8'>
            {actionButton && (
              <Button
                variant='primary'
                size='md'
                onClick={() => {
                  actionButton.action();
                  closeErrorModal();
                }}
                className='w-full sm:w-auto'
              >
                {actionButton.title}
              </Button>
            )}
            <Button
              variant='secondary'
              size='md'
              icon={Mail}
              onClick={handleContactSupport}
              className='w-full sm:w-auto'
            >
              Contact support
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
